import {ChecklistPage} from '@features/hroc-checklists'
import {useParams} from 'react-router'

type PathParameter = {
  plantId?: string
  checklistId?: string
}

export const PlantChecklistPage = () => {
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('plantId is missing')

  return <ChecklistPage plantId={plantId} />
}
